import "core-js/modules/web.dom-collections.iterator.js";
import { action } from "mobx";
import { createElement } from "react";
import FeatureLink from "../Generic/FeatureLink";
import CustomComponent from "./CustomComponent";

/**
 * A `<settingspanel>` custom component, that shows a link like button which when clicked
 * opens the settings panel.
 *
 * Props accepted
 *   - title - The text to use as alt link content
 *   - children - The link text
 *
 * Example: <settingspanel title="Open settings panel">Change base map</settingspanel>
 */
export default class SettingsPanelLinkCustomComponent extends CustomComponent {
  get name() {
    return "settingspanel";
  }
  get attributes() {
    return ["title"];
  }
  processNode(_context, node, children) {
    var _node$attribs;
    return /*#__PURE__*/createElement(FeatureLink, {
      title: (_node$attribs = node.attribs) === null || _node$attribs === void 0 ? void 0 : _node$attribs.title,
      onClick: action(viewState => viewState.openSettingsPanel())
    }, ...children);
  }
}